import { getConfigByKey } from '~features/tenantConfig/services'
import { tenantEnvConfig } from '../constants/tenantConfig/tenantEnvConfig'

const defaultLocales = ['vi', 'en']
const PROJECT_W_LOCALES = ['en', 'ko']
const ESCONDIDO_LOCALES = ['en', 'es']

export const getLocales = () => {
  let tenantLocales = getConfigByKey('locales')
  if (!tenantLocales) {
    const theme = tenantEnvConfig.ui_theme
    if (theme === 'projectw') {
      tenantLocales = PROJECT_W_LOCALES
    } else if (theme === 'escondido') {
      tenantLocales = ESCONDIDO_LOCALES
    } else {
      tenantLocales = defaultLocales
    }
  }

  if (typeof tenantLocales === 'string') {
    tenantLocales = tenantLocales.split(',')
  }

  return tenantLocales
}
